<template>
  <div class="edu">
    <breadcrumb></breadcrumb>
    <div class="edu-content">
      <div class="state-list">
        <span>
          <span
            class="state"
            @click="changeState(i.value)"
            :class="form.activeStatus === i.value ? 'active' : ''"
            v-for="i in resOptions.stateList"
            :key="i.value"
            >{{ i.name }}</span
          >
        </span>
        <div class="fr">
          <el-button
            v-if="power(userInfo.menuInfoList, 'topicResearch-export')"
            type="primary"
            class="el-icon-upload2"
            size="small"
            @click="toExport"
            >导出</el-button
          >
          <el-button
            v-if="power(userInfo.menuInfoList, 'topicResearch-addActive')"
            type="primary"
            class="el-icon-plus"
            size="small"
            @click="toPathAdd"
            >新增项目课题研究</el-button
          >
        </div>
      </div>
      <div class="search-list">
        <span>
          <span>项目课题研究类型</span>
          <dic-code-selector
            style="margin: 0px 10px"
            @change="query"
            dicType="topicLevel"
            v-model="form.classify4"
          ></dic-code-selector>
          <el-date-picker
            style="margin-right: 10px"
            size="small"
            v-model="form.queryDate"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="query"
          ></el-date-picker>
          <el-checkbox-group
            @change="query"
            v-model="form.checkIsMe"
            class="check-me"
          >
            <el-checkbox label="1">我参与的</el-checkbox>
            <el-checkbox label="0">我发布的</el-checkbox>
          </el-checkbox-group>
        </span>

        <el-input
          class="input-length"
          size="small"
          placeholder="搜索项目课题研究名称"
          style="width: 250px"
          v-model="form.keyword"
          clearable
        >
          <el-button
            slot="append"
            type="primary"
            class="search-btn"
            size="small"
            @click="query"
            >搜索</el-button
          >
        </el-input>
      </div>
      <div class="data-list" v-loading="pageLoading">
        <card-list
          moduleType="topicResearch"
          :dataList="dataList"
          @delSuccess="query"
        ></card-list>
        <!-- 分页 -->
        <pagination
          :pageObj="pageObj"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue'
import CardList from '@/components/common/CardList.vue'
import DicCodeSelector from '@/components/common/DicCodeSelector.vue'
import Pagination from '@/components/Pagination.vue'
import { postData, postJson } from '@/http/fetch.js'
import { fileSaveZip, power } from '@/utils/index.js'
import { mapGetters, mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['userInfo', 'resOptions']),
    ...mapGetters(['schoolCodes'])
  },
  components: {
    CardList,
    Breadcrumb,
    Pagination,
    DicCodeSelector
  },
  data() {
    return {
      form: {
        actType: 'topic',
        activeStatus: 1,
        classify4: '',
        schoolCodes: [],
        // classify2: "",
        checkIsMe: [], //无用
        isMe: '', // 空 全部
        keyword: '',
        operatorId: '',
        pageNum: '',
        pageSize: '',
        queryDate: null
      },
      pageObj: {
        current: 1,
        total: 0,
        size: 8,
        sizeList: [8, 16, 24, 32]
      },
      pageLoading: true,
      dataList: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    toExport() {
      this.pageLoading = true
      postData('/topic/exportTopicInfo', {
        ...this.form,
        queryEndTime: this.form.queryDate ? this.form.queryDate[1] : null,
        queryStartTime: this.form.queryDate ? this.form.queryDate[0] : null
      })
        .then((data) => {
          fileSaveZip(data.url, data.name)
          this.pageLoading = false
        })
        .catch(() => {
          this.pageLoading = false
        })
    },
    power,
    init() {
      this.selectData()
    },
    async selectData() {
      console.log('this.form')
      try {
        this.pageLoading = true
        this.form.operatorId = this.userInfo.userId
        // this.form.schoolCodes = this.schoolCodes;
        this.form.pageNum = this.pageObj.current
        this.form.pageSize = this.pageObj.size
        let { current, total, size, records } = await postJson(
          '/topic/getActiveInfoList',
          {
            ...this.form,
            queryEndTime: this.form.queryDate ? this.form.queryDate[1] : null,
            queryStartTime: this.form.queryDate ? this.form.queryDate[0] : null
          }
        )
        console.log(records)
        this.pageObj.total = total
        this.dataList = records
        this.pageLoading = false
      } catch (err) {
        console.log('err', err)
      }
    },
    changeState(code) {
      this.pageObj.current = 1
      this.pageObj.size = 8
      this.form.activeStatus = code
      this.selectData()
    },
    toPathAdd() {
      sessionStorage.removeItem('actCode')
      this.$router.push('editTopic')
    },
    query() {
      this.pageObj.current = 1
      this.selectData()
    },
    //分页
    handleSizeChange(pageSize) {
      this.pageObj.current = 1
      this.pageObj.size = pageSize
      this.selectData()
    },
    handleCurrentChange(curPage) {
      this.pageObj.current = curPage
      this.selectData()
    }
  },
  watch: {
    'form.checkIsMe': {
      handler(val, oldVal) {
        if (val.length == 1) {
          this.form.isMe = val[0]
        } else {
          this.form.isMe = ''
        }
      }
    }
  }
}
</script>


